<script setup>
import { ref, watch } from 'vue';
import { AxiosAPI } from '@/axios';
import { useMainStore } from '../../../stores/index';
import ModalMain from './ModalMain.vue';
import ModalResponsable from './ModalResponsable.vue';
import ToDoList from './ToDoListCreate.vue';
import RequiredFill from '../Modals/RequiredFill.vue';
import moment from 'moment';

const emit = defineEmits(['CreateTask']);

const Store = useMainStore();

const viewDocument = ref(null);
const modalResponsable = ref(null);
const RequiredFillRef = ref(null);
const todolist = ref(null);
const fileInput = ref(null);

const NameTask = ref('');
const DescriptionTask = ref('');
const Users = ref([]);
const DateStart = ref('');
const month = ref('');
const week = ref('');
const day = ref('');
const place = ref('');
const placeLink = ref('');
const allDay = ref(false);
const frequency_type = ref(1);
const priority = ref({ label: 'Baixa', value: 1 });
const priorityLabels = ref([
  { label: 'Baixa', value: 1 },
  { label: 'Média', value: 2 },
  { label: 'Alta', value: 3 }
]);
const status = ref({ label: 'À iniciar', value: 1, severity: 'secondary' });
const statuses = ref([
  { label: 'À iniciar', value: 1, severity: 'secondary' },
  { label: 'Em andamento', value: 2, severity: 'info' },
  { label: 'Concluída', value: 3 },
  { label: 'Bloqueado', value: 4, severity: 'danger' }
]);
const attachments = ref([]);
const tack = ref([]);
const hour = ref('');
const loading = ref(false);

watch(DateStart, (value) => {
  if (!value) return;
  moment.locale('pt-br');
  day.value = moment(value).format('DD');
  week.value = moment(value).format('dddd');
  month.value = moment(value).format('MMMM');
});

const openCreateTask = (value) => {
  Store.responsableTask = Store.user;
  const hoje = new Date(value);
  const dia = String(hoje.getDate()).padStart(2, '0');
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const ano = hoje.getFullYear();
  const FormatedData = `${ano}-${mes}-${dia}`;

  DateStart.value = FormatedData;
  moment.locale('pt-br');
  day.value = moment().format('DD');
  week.value = moment().format('dddd');
  month.value = moment(FormatedData).format('MMMM');
  loading.value = false;

  NameTask.value = '';
  DescriptionTask.value = '';
  Users.value = [];
  place.value = '';
  placeLink.value = '';
  allDay.value = false;
  frequency_type.value = 1;
  priority.value = { label: 'Baixa', value: 1 };
  status.value = { label: 'À iniciar', value: 1, severity: 'secondary' };
  attachments.value = [];
  tack.value = [];
  hour.value = '';

  if (viewDocument.value) {
    viewDocument.value.openModal();
  }
};

const editResponsable = () => {
  if (modalResponsable.value) {
    modalResponsable.value.openModal('teste');
  }
};

const CreateTask = () => {
  loading.value = true;
  if (!NameTask.value || !DateStart.value) {
    if (RequiredFillRef.value) {
      RequiredFillRef.value.openModal();
    }
    loading.value = false;
    return;
  }

  const userIds = Users.value.map(u => u.id);
  const checklist = todolist.value ? JSON.stringify(todolist.value.lists) : JSON.stringify([]);

  const formData = new FormData();
  formData.append('title', NameTask.value);
  formData.append('description', DescriptionTask.value || '');
  formData.append('recurrence_type', frequency_type.value);
  formData.append('date', DateStart.value);
  formData.append('hour', hour.value || '');
  formData.append('location', place.value || '');
  formData.append('access_link', placeLink.value || '');
  formData.append('priority', priority.value.value || priority.value);
  formData.append('responsible_id', Store.responsableTask?.id);
  formData.append('situation', status.value.value || status.value);

  userIds.forEach(uId => {
    formData.append('users[]', uId);
  });

  tack.value.forEach(file => {
    formData.append('attachments[]', file);
  });

  formData.append('checklists', checklist);

  AxiosAPI.post('/api/tasks', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${Store.accessToken}`
    }
  }).then(() => {
    NameTask.value = '';
    DescriptionTask.value = '';
    Users.value = [];
    DateStart.value = '';
    hour.value = '';
    place.value = '';
    placeLink.value = '';
    priority.value = { label: 'Baixa', value: 1 };
    status.value = { label: 'À iniciar', value: 1, severity: 'secondary' };
    attachments.value = [];
    tack.value = [];
    Store.responsableTask = Store.user;

    emit('CreateTask');
    if (viewDocument.value) {
      viewDocument.value.closeModal();
    }
  }).catch(error => {
    console.error('Erro ao criar tarefa:', error);
  }).finally(() => {
    loading.value = false;
  });
};

const addAttachment = (event) => {
  const files = Array.from(event.target.files);
  const newFiles = files.filter(file =>
    !tack.value.some(existingFile => existingFile.name === file.name)
  );

  attachments.value.push(...newFiles.map(file => ({ name: file.name })));
  tack.value.push(...newFiles);
};

const removeAttachment = (index) => {
  attachments.value.splice(index, 1);
  tack.value.splice(index, 1);
};

const openFileInput = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};

defineExpose({
  openCreateTask
});
</script>

<style scoped>
.dropdown-content p {
  margin: 0;
  padding: 8px;
  cursor: pointer;
}
.dropdown-content p:hover {
  background-color: #f0f0f0;
}
</style>

<template>
  <div>
    <ModalResponsable ref="modalResponsable"/>
    <RequiredFill ref="RequiredFillRef" />
    <ModalMain ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h5 class="font-docs"><b>Nova atividade</b></h5>
          </div>
          <div>
            <button
              id="close"
              type="button"
              class="close"
              @click="viewDocument.closeModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <template #body>
        <div>
          <div class="row">
            <div class="col">
              <label class="label-docs mt-3">Data <span style="color:red">*</span></label>
              <input type="date" class="my_form" v-model="DateStart" />
            </div>
            <div class="col">
              <label class="label-docs mt-3">Horário</label>
              <input type="time" class="my_form" v-model="hour" />
            </div>
            <div class="col">
              <label class="label-docs mt-3">Situação <span style="color:red">*</span></label>
              <Dropdown
                v-model="status"
                :options="statuses"
                optionLabel="label"
                placeholder="Selecione um status"
                class="w-100"
              >
                <template #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <Tag v-if="slotProps.value.label === 'À iniciar' || slotProps.value === '1'" rounded style='background-color: #E9ECEF;color:#6C757D;padding: 0rem 0.75rem !important;'>
                      <span class='text-base font-docs'><b>À iniciar</b></span>
                    </Tag>
                    <Tag v-if="slotProps.value.label === 'Em andamento' || slotProps.value === '2'" rounded style='background-color: #CFF4FC;color: #087990;padding: 0rem 0.75rem !important;'>
                      <span class='text-base font-docs'><b>Em andamento</b></span>
                    </Tag>
                    <Tag v-if="slotProps.value.label === 'Bloqueado' || slotProps.value === '4'" rounded style='background-color: #F8D7DA;color: #842029;padding: 0rem 0.75rem !important;'>
                      <span class='text-base font-docs'><b>Bloqueado</b></span>
                    </Tag>
                    <Tag v-if="slotProps.value.label === 'Concluída' || slotProps.value === '3'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);padding: 0rem 0.75rem !important;'>
                      <span class='text-base font-docs'><b>Concluída</b></span>
                    </Tag>
                  </div>
                </template>
                <template #option="{ option }">
                  <Tag v-if="option.label === 'À iniciar'" rounded style='background-color: #E9ECEF;color:#6C757D;'>
                    <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                  </Tag>
                  <Tag v-if="option.label === 'Em andamento'" rounded style='background-color: #CFF4FC;color: #087990;'>
                    <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                  </Tag>
                  <Tag v-if="option.label === 'Bloqueado'" rounded style='background-color: #F8D7DA;color: #842029;'>
                    <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                  </Tag>
                  <Tag v-if="option.label === 'Concluída'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);'>
                    <span class='text-base font-docs'><b>{{ option.label }}</b></span>
                  </Tag>
                </template>
              </Dropdown>
            </div>
            <div class="col">
              <label class="label-docs mt-3">Prioridade</label>
              <Dropdown
                v-model="priority"
                :options="priorityLabels"
                optionLabel="label"
                placeholder="Selecione uma prioridade"
                class="w-100"
              >
                <template #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <div v-if="slotProps.value.label === 'Baixa' || slotProps.value === 1" class="d-flex">
                      <i class="fa-solid fa-angle-up mr-1" style="color:#0D6EFD;position: relative; top: 5px;"></i>
                      <span>Baixa</span>
                    </div>
                    <div v-if="slotProps.value.label === 'Média' || slotProps.value === 2" class="d-flex">
                      <i class="fa-solid fa-angle-up mr-1" style="color:#FFC107;position: relative; top: 5px;"></i>
                      <span>Média</span>
                    </div>
                    <div v-if="slotProps.value.label === 'Alta' || slotProps.value === 3" class="d-flex">
                      <i class="fa-solid fa-angle-up mr-1" style="color:#F76659;position: relative; top: 5px;"></i>
                      <span>Alta</span>
                    </div>
                  </div>
                </template>
                <template #option="{ option }">
                  <div v-if="option.label === 'Baixa'" class="d-flex">
                    <i class="fa-solid fa-angle-up mr-1" style="color:#0D6EFD;position: relative; top: 5px;"></i>
                    <span>{{ option.label }}</span>
                  </div>
                  <div v-if="option.label === 'Média'" class="d-flex">
                    <i class="fa-solid fa-angle-up mr-1" style="color:#FFC107;position: relative; top: 5px;"></i>
                    <span>{{ option.label }}</span>
                  </div>
                  <div v-if="option.label === 'Alta'" class="d-flex">
                    <i class="fa-solid fa-angle-up mr-1" style="color:#F76659;position: relative; top: 5px;"></i>
                    <span>{{ option.label }}</span>
                  </div>
                </template>
              </Dropdown>
            </div>
          </div>

          <div class="mt-3">
            <div class="d-flex align-items-center">
              <input type="checkbox" class="mr-2" v-model="allDay"/>
              <span class="label-docs mr-1" style="width:80px">Dia inteiro</span>
              <select class="my_form" v-model="frequency_type">
                <option value="1">Não se repete</option>
                <option value="2">Todos os dias</option>
                <option value="3">Semanal: toda {{ week }}</option>
                <option value="4">Mensal: dia {{ day }}</option>
                <option value="5">Anual: em {{ month }} {{ day }}</option>
              </select>
            </div>
          </div>

          <div class="mt-2">
            <label class="label-docs">Nome <span style="color:red">*</span></label>
            <input type="text" class="my_form" v-model="NameTask" placeholder="Nome da tarefa" />
          </div>

          <div>
            <label class="label-docs mt-1">Descrição</label>
            <textarea name="Description" id="Description" v-model="DescriptionTask" class="my_form" style="height: 86px;"></textarea>
          </div>

          <div class="row">
            <div class="col">
              <label class="label-docs mt-3">Local</label>
              <input type="text" v-model="place" class="my_form" placeholder="Meet" />
            </div>
            <div class="col">
              <label class="label-docs mt-3">Link de acesso à videoconferência</label>
              <input type="text" v-model="placeLink" class="my_form" placeholder="https://meet.google.com/"/>
            </div>
          </div>

          <div>
            <ToDoList ref="todolist"/>
          </div>

          <div v-if="!Store.mobile" class="d-flex justify-content-between">
            <div class="w-100">
              <label class="label-docs mt-3">Convidados</label>
              <MultiSelectPrime
                display="chip"
                v-model="Users"
                :options="Store.users"
                filter optionLabel="name"
                placeholder="Selecione os envolvidos na tarefa"
                :maxSelectedLabels="3"
                style="z-index: 9999 !important; height: calc(3.475rem + 2px);"
                class="w-full my_form">
                <template #option="slotProps">
                  <div class="d-flex align-items-center">
                    <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;" />
                    <div>{{ slotProps.option.name }}</div>
                  </div>
                </template>
                <template #footer>
                  <div class="py-2 px-3">
                    <b>{{ Users ? Users.length : 0 }}</b> usuário(s) selecionado(s).
                  </div>
                </template>
              </MultiSelectPrime>
            </div>

            <div class="d-grid ml-5">
              <label class="label-docs mt-3">Responsável</label>
              <div class="d-flex align-items-center">
                <img
                  :src="$userAvatar(Store.responsableTask?.path_image)"
                  alt="Avatar"
                  class="mr-2"
                  style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;">
                <div class="d-grid">
                  <span class="font-docs"><b>{{ Store.responsableTask?.name }}</b></span>
                  <span class="font-docs">{{ Store.responsableTask?.email }}</span>
                </div>
                <i class="fa-solid fa-pen Color-Docs ml-2" style="font-size: 25px; cursor:pointer" @click="editResponsable"></i>
              </div>
            </div>
          </div>

          <div v-if="Store.mobile">
            <div class="w-100">
              <label class="label-docs mt-3">Convidados</label>
              <MultiSelectPrime
                display="chip"
                v-model="Users"
                :options="Store.users"
                filter optionLabel="name"
                placeholder="Selecione os envolvidos na tarefa"
                :maxSelectedLabels="3"
                style="z-index: 9999 !important; height: calc(3.475rem + 2px);"
                class="w-full my_form">
                <template #option="slotProps">
                  <div class="d-flex align-items-center">
                    <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;" />
                    <div>{{ slotProps.option.name }}</div>
                  </div>
                </template>
                <template #footer>
                  <div class="py-2 px-3">
                    <b>{{ Users ? Users.length : 0 }}</b> usuário(s) selecionado(s).
                  </div>
                </template>
              </MultiSelectPrime>
            </div>

            <div class="d-grid">
              <label class="label-docs mt-3">Responsável</label>
              <div class="d-flex align-items-center">
                <img
                  :src="$userAvatar(Store.responsableTask?.path_image)"
                  alt="Avatar"
                  class="mr-2"
                  style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;">
                <div class="d-grid">
                  <span class="font-docs"><b>{{ Store.responsableTask?.name }}</b></span>
                  <span class="font-docs">{{ Store.responsableTask?.email }}</span>
                </div>
                <i class="fa-solid fa-pen Color-Docs ml-2" style="font-size: 25px; cursor:pointer" @click="editResponsable"></i>
              </div>
            </div>
          </div>

          <button class="btn Color-Docs mt-5" style="border: 1px solid #F1860B" @click='openFileInput'>
            <i class="fa-solid fa-arrow-up-from-bracket mr-2"></i>
            <input type='file' ref='fileInput' @change='addAttachment' accept='.doc,.docx,.odt,.pdf,.png,.jpg,.svg' style='display: none' multiple/>
            Adicionar arquivo
          </button>

          <div class='ml-3 mt-2 mb-4'>
            <div class='mt-3'>
              <span v-for='(attachment, index) in attachments' :key='index' class='d-flex ml-2 Color-Docs' style='height: 40px;align-items: center;'>
                <i class="fa fa-file-o mr-2" aria-hidden="true"></i>
                {{attachment.name}}
                <button type='button' @click='removeAttachment(index)' style='border: none;'>
                  <i class="fa fa-trash-o ml-2" aria-hidden="true" style="color: #212529"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn Color-Docs font-docs mr-3" style="border: 1px solid #F1860B" @click="viewDocument.closeModal()">
            Voltar
          </button>
          <button class="btn background-Docs text-white font-docs" @click="CreateTask" :disabled="loading">
            Cadastrar
          </button>
        </div>
      </template>
    </ModalMain>
  </div>
</template>